import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
import { Divider, Col, Row } from 'antd'
export const SectionWrapper = styled(Flex)`
  width: 100%;
`
export const OuterDiv = styled.div`
  border: 1px solid ${COLORS.PAGE_BORDER};
  background: ${COLORS.WHITE};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  margin: 30px 100px 20px 100px;
  border-radius: 10px;
   @media only screen and (min-width: 1200px) and (max-width: 1300px) {
    margin: 30px 20px 20px 20px;
  }
`

export const TopNav = styled(Flex)`
  height: auto;
  // background-color: #fafafb;
  // padding: 30px;
  flex-direction: column;
`

export const SectionName = styled.div`
  margin-left: 20px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
`

export const TitleMedium = styled.h2`
  font-style: normal;
  font-weight: ${props => (props.fontweight ? props.fontweight : FONT.FW_700)};
  font-size: ${FONT.F_2XL};
  line-height: 30px;
  color: ${COLORS.GREY_T_30};
  margin-bottom: 0;
`
export const SubtitleLarge = styled.h2`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_LG};
  line-height: 24px;
  padding-left: 10px
  color: ${props => (props.color ? props.color : COLORS.GREY_T_30)};
  margin-bottom: 5px;
`
export const GrayTextSmall = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 30px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_30)};
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '0px')};
`

export const InfoText = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_BASE};
  line-height: 30px;
  color: ${COLORS.GREY_T_50_2};
  margin-bottom: 0;
  margin-left: ${props => (props.marginleft ? props.marginleft : '0px')};
  padding-top: ${props => (props.paddingTop ? props.paddingTop : '')};
  word-wrap: break-word;
`

export const YellowBox = styled(Flex)`
  padding: 10px;
  background: ${COLORS.ORANGE_T_92};
  border: 1px solid ${COLORS.ORANGE_T_60};
  border-radius: 10px;
  gap: 15px;
`

export const FlexWrap = styled(Flex)`
  position: relative;
  gap: ${props => (props.gap ? props.gap : '0px')};
  padding: ${props => (props.padding ? props.padding : '0px')};
  background-color: ${props => (props.bgColor ? props.bgColor : 'transparent')};
`
export const GrayText = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_60};
  margin-bottom: 0;
`

export const SubtitleSmall = styled.p`
  font-style: normal;
  font-weight: ${props => (props.fontweight ? props.fontweight : FONT.FW_400)};
  font-size: ${props => (props.fontsize ? props.fontsize : FONT.F_SM)};
  line-height: 20px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_30)};
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '5px')};
  span {
    font-style: normal;
    font-weight: ${FONT.FW_600};
    line-height: 18px;
    color: ${COLORS.GREY_T_10};
    margin-right: 5px;
  }
`

export const SubtitleMedium = styled.h2`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  color: ${COLORS.GREY_T_10};
  margin-bottom: 0;
`

export const VerticalDivider = styled(Divider)`
  height: 20px;
`

export const FlexContain = styled(Flex)`
  padding: 15px 0px;
`
export const FlexContain1 = styled(Flex)`
  padding: 5px 0px;
`
export const LeftCol = styled(Col)`
  padding: 10px;
`
export const Editor = styled.div`
  width: 75%;
  padding: 10px;
`
export const Address = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #1b1f22;
  opacity: 0.48;
`
export const NameAdd = styled(Flex)`
  gap: 3px;
  padding-left: 15px;
`
export const Container = styled(Flex)`
  padding-right: 20px;
  flex-direction: row-reverse;
`
export const Name = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #343e59;
`
export const BreadCrumns = styled.div`
  display: flex;
`
export const RowContainer = styled(Row)`
  padding: 30px;
`

export const EditorContent = styled.span`
  padding: 20px 0;
  * {
    line-height: 188%;
    color: #808697 !important;
  }
  p,
  ul,
  ol {
    margin-bottom: 10px;
  }

  li {
    line-height: 25px;
  }
`
export const PopHeading = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #343e59;
  padding-top: 15px;
  padding-bottom: 5px;
`
export const PopSubHeading = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #808697;
  padding-top: 5px;
`
export const PopSubHeadingLI = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 25px;
  color: #808697;
  padding-top: 5px;
`

export const Name1 = styled.div`
  font-weight: 600;
  font-size: 16px;
  height: 24px;
  line-height: 22px;
  text-align: center;
  color: #343e59;
`
export const Address1 = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #1b1f22;
  opacity: 0.48;
`
export const Frame = styled.div`
  padding: 20px;
`
export const SubBold = styled.span`
  font-weight: bold;
  color: #343e59;
`

export const Container1 = styled.div`
  height: ${props => (props.expanded ? 'auto' : '250px')};

  overflow: hidden;
  overflow-wrap: break-word;
`

export const Content = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 25px;
  color: #808697;
`

export const ExtraPadding = styled.div`
  padding-bottom: 8px;
`

export const ShowMoreText = styled.span`
  cursor: pointer;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 10px;
  padding-right: 10px;
  color: #000;
  display: ${props => (props.visible ? 'inline-block' : 'none')};
  border-radius: 10px;
  background-color: #e6e7ea;
`

export const TextMedium1 = styled.div`
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
  color: #343e59;
`

export const TagLebelDiv = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #000000;
  padding-right: 15px;
  margin-top: -5px;
`
export const RightDiv = styled.div`
  position: absolute;
  right: 0%;
  width: 50%;
  background-color: ${props => getOrderBasedColor(props.orderNo).background};
  border: 1px solid ${props => getOrderBasedColor(props.orderNo).borderColor};
  border-radius: 5px;
`
export const RightDiv1 = styled.div`
  width: 50%;
  background-color: ${props => getOrderBasedColor(props.orderNo).background};
  border: 1px solid ${props => getOrderBasedColor(props.orderNo).borderColor};
  border-radius: 5px;
`
const getOrderBasedColor = orderNo => {
  if (orderNo === null) {
    return {
      // Default styling
      color: '#000000',
      borderColor: '#DBDBDB',
      background: '#EDEDED1A',
    }
  }
  switch (orderNo) {
    case 1:
      return {
        color: '#000000',
        borderColor: '#CCCCCC',
        background: '#CCCCCC33', // 20% opacity of #CCCCCC
      }
    case 2:
      return {
        color: '#000000',
        borderColor: '#97CADB',
        background: '#97CADB33', // 20% opacity of #97CADB
      }
    case 3:
      return {
        color: '#000000',
        borderColor: '#B5A3F7',
        background: '#B5A3F733', // 20% opacity of #B5A3F7
      }
    case 4:
      return {
        color: '#000000',
        borderColor: '#E1A7BA',
        background: '#E1A7BA33', // 20% opacity of #E1A7BA
      }
    case 5:
      return {
        color: '#000000',
        borderColor: '#F29F05',
        background: '#F29F0533', // 20% opacity of #F29F05
      }
    case 6:
      return {
        color: '#000000',
        borderColor: '#F25C05',
        background: '#F25C0533', // 20% opacity of #F25C05
      }
    case 7:
      return {
        color: '#000000',
        borderColor: '#72B06F',
        background: '#72B06F33', // 20% opacity of #72B06F
      }
    case 8:
      return {
        color: '#000000',
        borderColor: '#4C1D91',
        background: '#4C1D9133', // 20% opacity of #4C1D91
      }
    case 9:
      return {
        color: '#000000',
        borderColor: '#02457A',
        background: '#02457A33', // 20% opacity of #02457A
      }
    case 10:
      return {
        color: '#000000',
        borderColor: '#595F33',
        background: '#595F3333', // 20% opacity of #595F33
      }
    case 11:
      return {
          borderColor: '#000000',
      }
    default:
      return {
        // Default style for unmatched cases
        color: '#000000',
        borderColor: '#DBDBDB',
        background: '#DBDBDB33', // 20% opacity of #DBDBDB
      }
  }
}
export const JDDescription = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 25.2px;
  color: #1a2645;
  padding-bottom: 10px;
`
export const RightContentOuter = styled.div`
  margin: 50px 15px;
`
export const InnerBodyText = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #4d566e;
`
export const TimeInfo = styled.div`
  padding: 10px;
  background-color: #fbfaff;
  border-radius: 10px;

  align-content: center;
  border: 1px solid #e3deff;
  padding-right: 30px;
`
export const TimeIcon = styled.div`
  display: flex;
  border-radius: 10px;
  background-color: #f3f3f3;
  align-content: center;
  justify-content: center;
  align-items: center;
  justify-items: center;
  width: 40px;
  height: 40px;
  margin-right: 10px;
`

export const TimeLabel = styled.div`
  font-weight: ${({ title }) => (title ? 400 : 600)};
  color: ${({ color }) => color ?? COLORS.GREY_T_60};
  font-size: 14px;
`

export const TimeDateDivision = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`
export const SubtitleSmall1 = styled.p`
  font-style: normal;
  font-weight: ${props => (props.fontweight ? props.fontweight : FONT.FW_400)};
  font-size: ${props => (props.fontsize ? props.fontsize : FONT.F_SM)};
  line-height: 20px;
  white-space: ${props => (props.nowrap ? 'nowrap' : 'normal')};
  color: ${props => (props.color ? props.color : COLORS.GREY_T_30)};
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '5px')};
  padding: ${props => (props.padding ? props.padding : '')};
  text-transform: ${props => (props.capitalize ? 'capitalize' : 'none')};
  width: ${props => (props.width ? props.width : '')};

  @media (max-width: 1100px) {
    width: auto;
  }
  span {
    font-style: normal;
    font-weight: ${FONT.FW_600};
    line-height: 18px;
    color: ${COLORS.GREY_T_10};
    margin-right: 5px;
  }
  ${props => props.afterContent && `::after { content: ',';}`}

  :last-child:after {
    content: '';
  }
`

export const EligibleSubTitle = styled.div`
  font-size: 15px;
  font-weight: 700;
  line-height: 21px;
  padding-left: ${props => (props.padding ? props.padding : '10px')};
  color: #000000;
`
export const YOPText = styled.div`
  font-size: 15px;
  font-weight: 500;
  line-height: 25px;
  color: #010e30;
`

export const SkillSubTitle = styled.div`
  font-size: 15px;
  font-weight: 400;
  line-height: 18px;
  padding: 5px 0px;
  color: #000000;
`

export const GetTPOContent = styled.p`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #4d566e;
  span {
    font-weight: 700;
  }
`
export const LapsedButton = styled.div`
  width: ${props => (props.width ? props.width : '120px')};
  height: ${props => (props.height ? props.height : '40px')};
  background: ${props => (props.background ? props.background : '#F0F0F0')};
  color: ${props => (props.color ? props.color : '#808080')};
  border-radius: 10px;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;

  display: flex;
  align-items: center;
  justify-content: center;
`


export const StyledCardDiv = styled(Flex)`
  
  padding: 12px;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  height: ${props => (props?.height ? props.height : '63px')};
  background: #ffffff;
  border: 1px solid #e6e7ea;
  border-radius: 10px;
  width: ${props => (props?.width ? props.width : '100%')};
`

export const StyledImg = styled(Flex)`
  padding: 10px 10px 10px 0px;
  gap: 5px;
`

export const StyledH2 = styled.h2`
  font-style: normal;
  font-weight: ${props => (props?.fontWeight ? props.fontWeight : '600')};
  font-size: 14px;
  line-height: 120%;

  color: #4d566e;
`

export const AdjustIcon = styled.div`
  margin-top: ${props => (props?.marginTop ? '7px' : '2px')};
  margin-right: ${props => props?.marginRight && '7px'};
  align-content: ${props => props?.alignContent && 'center'};
`
export const StyledDelete = styled.div`
  cursor: pointer;
  z-index: 1;
  margin-left: ${props => (props?.marginLeft ? '0px' : '23px')};
`

export const ButtonDiv = styled.div`
  margin-right: 10px;
`
export const CompensationWrapper = styled(Flex)`
  gap: 12px;
  padding: 8px 12px;
  border: 1px solid ${COLORS.GREY_T_90};
  border-radius: 8px;
  background: #ffffff;
  align-items: center;
  white-space: nowrap;
`
export const CompensationText = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 10px;          /* ⬅️ increased gap */
  white-space: nowrap;
  font-size: 14px;
  color: #000;
`
export const CompensationAmount = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: ${COLORS.BLACK};
`
export const CompensationBreakup = styled.span`
  display: inline-flex;   /* ⬅️ important */
  align-items: center;
  gap: 6px;               /* ⬅️ spacing between words */
  font-size: 13px;
  color: #000;
  white-space: nowrap;
`
